export default {
    createGroup: 'Create Group',
    groupName: 'Group Name',
    checkInOption: 'Check-in option',
    checkInByLine: 'Check-in by Line',
    checkInAnyWhere: 'Check-in anywhere',
    enterGroupName: 'Enter Group Name',
    workday: 'Workday',
    day: 'Day',
    startTime: 'Start Time',
    breakHours: 'Break Hours',
    endTime: 'End Time',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    save: 'Save',
    cancel: 'Cancel',
    msgCannotModify: 'Cannot modify timetable of current weekday',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    congratulation: 'Congratulation',
    msgCreateSuccess: 'Group is created',
    msgUpdateSuccess: 'Group is updated',
    msgError: 'Error Message',
    days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
    },
    // msgThanTimeStart: 'Please select the time more than time start',
    checkInTime: 'Check In Time',
    totalWorkHours: 'Total Work Hours',
    workingTimeEachDay: 'Working time each day is not permitted to work more than 24 hrs.',
    limitsWorkingHours: 'Limits on working hours is not permitted to work more than 8 hours per day and 48 hrs a week.',
    maximumLimitsOvertime: 'Maximum Limits on overtime are not permitted to exceed 36 hrs in a week',
    information: 'Information',
    checkInShouldAfterEndTime: 'Check in time should be after the End time of the previous day.',
    incorrectWorkTimePeriod: 'incorrect work time period',
    checkInTimeOverlapStartTime: 'Check-in time is overlap start time',
    startTimeOverlapCheckInTime: 'Start time is overlap Check-in time',
    checkInTimeOverlapEndTime: 'Check-in time is overlap end time',
    endTimeOverlapCheckInTime: 'End time is overlap Check-in time',
    breakhoursIsRequired: 'breakhours is required',
    specialWorkdayOverlap: 'There is special workday overlap checkin - end time',
    otOverlap: 'There is overtime overlap checkin - end time',
    close: 'Close',
    error: 'Error'
}
